module.exports = __webpack_public_path__ + "static/media/testImage6.5ee8d3d9.png";